import { Redirect, useLocalSearchParams } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams();

  return <Redirect withAnchor href={{ pathname: '/account/gift', params }} />;
}
